import "./AdvanceYourCareer.module.css";
import Header from "@/reusable_sections/Header";
import HeroPrimaryCallToAction from "./sections/HeroPrimaryCallToAction";
import ImpactSocial from "./sections/ImpactSocial";
import Overview from "./sections/Overview";
import Footer from "@/reusable_sections/Footer";
export default function AdvanceYourCareerPage() {
  return <div>
      <Header />
      <HeroPrimaryCallToAction />
      <ImpactSocial />
      <Overview />
      <Footer />
    </div>;
}